import { PdsWidget } from '../../pds-widget';
import {MultiFieldFilter} from '../../models/grid-widget/multi-field-filter';

export class PdsGwMultiFieldFilter extends PdsWidget {
  is = 'pds-gw-multi-field-filter';
  id: string;
  filter: MultiFieldFilter | null;

  properties = {
    id: {
      type: String,
      value: null
    },
    filter: {
      value: null
    }
  };

  attached(): void {
    super.attached();
    let textElement: HTMLElement | null = this.querySelector('pds-text-widget');
    if (textElement != null) {
      textElement.addEventListener('modelValueChange', (event: Event) => {
        if (this.filter != null) {
          this.filter.searchValue = (event.target as any).modelValue;
          this.inputChange();
        }
      });
    }
  }

  inputChange(): void {
    let event: Event = new Event('renderedElementValueChange', {bubbles: true});
    this.dispatchEvent(event);
  }
}
